const AWS_RESOURCE_TYPES = {
  L4: 'cad854db-c733-4449-b109-a59e258a5e6e',
  V100: '4daa38b5-df6f-47ae-b70e-6c16315aca0e',
  T4: 'c735ed24-41af-41e7-94b6-57215768f068',
  A100: 'd99bf4f7-92b7-4622-9355-a7aa3f5469b5',
  A10G: 'c44f7bf1-fcf4-44f4-aba4-ba99f425f756',
  L40S: 'f102ec9d-a62f-412e-9ef9-488485b0071f',
  H100: 'da6aca1e-946c-4ff4-8283-e4ff592bf581',
  H200: '5a017ae6-97d4-409d-b329-ce8a6de8add3',
  B200: 'ecd70840-c5de-4fd3-b864-9d7f9a737bbd',
  B300: '35a09af6-704f-4333-b40b-1e8e93657bcb',
  RTX_PRO_4500: '33b3caf9-c76e-4f29-ac6e-5ebfc092a851',
  RTX_PRO_6000: '04fece29-a464-4902-a494-3ca87186ab10',
  CPU: '78201a90-ca48-4147-b6f5-fec51b4bd7db',
};
export default AWS_RESOURCE_TYPES;
